import { render, staticRenderFns } from "./BooksSetup.vue?vue&type=template&id=9a8ada0a&"
import script from "./BooksSetup.vue?vue&type=script&lang=js&"
export * from "./BooksSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports